import type { AppEnvironment } from './environment.types';
import { cleannoFirebaseWebConfig } from './firebase-web.config';

export const environment: AppEnvironment = {
  production: false,
  envBadge: 'DEVELOPMENT' as const,
  appUrl: 'https://dev.cleanno.be',
  marketingSiteUrl: 'https://cleanno.be',
  mobileAppScheme: 'be.cleanno.app',
  supabase: {
    url: 'https://liahmehamitrsndyugel.supabase.co',
    anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxpYWhtZWhhbWl0cnNuZHl1Z2VsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0Njk0OTIsImV4cCI6MjA4OTA0NTQ5Mn0.fxliY9DxBuEFSTlZBIsap7H8OP5x4pygV39HLRqqOsU'
  },
  stripe: {
    publishableKey: 'pk_test_51Sn1PRFMIhFyOWDZ2tXozwpslGOX1SFWF60EiUiZiJOUz3ZiQQSReOGQVYu4OwdIISPEjnr7S6sTgFVPq6u8mLK500Vk1Idbnz',
  },
  clarity: {
    projectId: null,
  },
  metaPixel: {
    id: '1440772230673031',
  },
  sentry: {
    dsn: null,
  },
  firebaseWeb: cleannoFirebaseWebConfig,
  features: {
    showExteriorCleaning: true,
    requireVatRegistryValidation: false,
    simplifiedCleanerOnboarding: true,
  },
};
